(() => {
  const init = () => {
    if (document.documentElement.dataset.mgRevealReady) return;
    document.documentElement.dataset.mgRevealReady = 'true';

    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const reveal = [...document.querySelectorAll('[data-mg-reveal], [data-mg-reveal-grid]')];
    if (!reveal.length) return;

    if (reduce || !('IntersectionObserver' in window)) {
      reveal.forEach((el) => el.classList.add('is-inview'));
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-inview');
          io.unobserve(entry.target);
        });
      },
      { threshold: 0.22, rootMargin: '0px 0px -6% 0px' }
    );

    reveal.forEach((el) => io.observe(el));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', () => {
    document.documentElement.dataset.mgRevealReady = '';
    init();
  });
})();
